import { axios } from '@/services/axios';

export const getResourceAcc = async (id) => {
    const res = await axios.get(`/ResourceAccount/${id}`);
    return res.data;
};
